import React, { useEffect } from 'react';

import Footer from 'components/layout/Footer';

import AircraftTable from './components/AircraftTable';

import { dynamicPx, TitleTypography } from 'components/common/Common';
import JetSaleContact from './components/JetSaleContact';
import aircraftJson from './data.json';

import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { camelCase, toTitleCase } from 'untils';
import { Breadcrumb, contentWidth, InfoIcon, MainContainer } from './JetSale.style';
import HeaderMeta from 'components/headerMeta/HeaderMeta';

const MainContainerWithMargin = styled(MainContainer)`
  margin: ${dynamicPx({ maxSize: 60, minSize: 44 })} 0;
`;

export const ContentContainer = styled(MainContainer)`
  ${contentWidth}
  max-width: 1300px;
`;

const aircraftHeader = {
  aircraft: 'Aircraft',
  seats: 'Seats',
  maxRange: 'Max Range (NM.)',
  endurance: 'Endurance (Hours.)',
  yearManufactured: 'The Year Manufactured',
  cabinHeight: 'Cabin Height (ft.)',
  cabinWeight: 'Cabin Weight (ft.)',
  cabinVolume: 'Cabin Volume (cu. ft.)',
  prices: 'Prices-new (million)',
  preOwned: 'PRE-OWNED/<12 years (million)',
};

const BackButton = styled(InfoIcon)`
  &:hover {
    background-image: url(../../imgs/svg/back_jump_hover.svg);
    background-color: black;
    border-radius: 0.5em;
    & > img {
      filter: invert(1);
    }
  }
`;
const JetSaleDetail = () => {
  const params = useParams();
  const history = useHistory();

  // Scroll to the top when nav to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    history.goBack();
  };

  const data =
    aircraftJson
      .find((cate) => camelCase(cate.category) === params.category)
      ?.aircraft.map(({ display, order, ...airInfo }) => {
        return airInfo;
      }) || [];

  return (
    <>
      <HeaderMeta type={params.category} />
      <MainContainerWithMargin>
        <Breadcrumb>
          <BackButton width={40} height={40} pointer onClick={goBack}>
            <img src={'/imgs/svg/go-back.svg'} alt="go back" />
          </BackButton>
          <TitleTypography $minSize={14} $maxSize={24}>
            {toTitleCase(params.category)} – Comparison
          </TitleTypography>
        </Breadcrumb>
        <ContentContainer>
          <AircraftTable data={data} header={aircraftHeader} category={params.category} />
          <JetSaleContact />
        </ContentContainer>
      </MainContainerWithMargin>
      <Footer />
    </>
  );
};

export default JetSaleDetail;
